module.exports = __webpack_public_path__ + "media/large/real_estate_apartments_rent-7d535317.jpeg";